import { NONE, DIRECTION_RIGHT, DIRECTION_LEFT, DIRECTION_DOWN, DIRECTION_UP } from '@any-touch/shared';

var getVLength = (function (v) {
    return Math.sqrt(v.x * v.x + v.y * v.y);
});

var getDotProduct = (function (v1, v2) {
    return v1.x * v2.x + v1.y * v2.y;
});

var getRadian = (function (v1, v2) {
    var mr = getVLength(v1) * getVLength(v2);
    if (mr === 0)
        return 0;
    var r = getDotProduct(v1, v2) / mr;
    if (r > 1)
        r = 1;
    return Math.acos(r);
});

var getCross = (function (v1, v2) {
    return v1.x * v2.y - v2.x * v1.y;
});

var radianToAngle = (function (radian) { return radian / Math.PI * 180; });

var getAngle = (function (v1, v2) {
    var angle = getRadian(v1, v2);
    if (getCross(v1, v2) > 0) {
        angle *= -1;
    }
    return radianToAngle(angle);
});

var getDirection = (function (x, y) {
    if (x === y) {
        return NONE;
    }
    else if (Math.abs(x) > Math.abs(y)) {
        return 0 < x ? DIRECTION_RIGHT : DIRECTION_LEFT;
    }
    else {
        return 0 < y ? DIRECTION_DOWN : DIRECTION_UP;
    }
});

export { getAngle, getCross, getDirection, getDotProduct, getRadian, getVLength, radianToAngle };
